import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import CenterPanelUpdate from './centerPanel';
import RightPanelUpdate from './rightPanel';
import { getLastInvite } from '../../../../actions/waitingArea';
import PopupHeader from '../../popupHeader';
import Modal from '../../../shared/modal/content';
export default function InviteWASelfProvisionContent(props) {
  const dispatch = useDispatch();

  const [isFetchingLastInvite, setIsFetchingLastInvite] = useState(false);
  const [hasUserValidInvitation, setHasUserValidInvitation] = useState(false);
  const [userLastInvited, setUserLastInvited] = useState({});
  const [invalidUserEmails, setInvalidUserEmails] = useState(true);
  const [ifCheckboxChecked, setIfCheckboxChecked] = useState(true);

  useEffect(() => {
    if (props.selectedUsers.length == 0) {
      setHasUserValidInvitation(false);
      setUserLastInvited({});
    }
  }, [props.selectedUsers]);

  const userSelectedCallBack = (selectedUser) => {
    let cb = (result, response) => {
      if (response && response.hasValidInvitation) {
        setHasUserValidInvitation(true);
        setUserLastInvited(response);
      } else {
        setHasUserValidInvitation(false);
        setUserLastInvited({});
      }

      if (result) {
        setInvalidUserEmails(true);
      } else {
        setInvalidUserEmails(false);
      }
    };
    dispatch(getLastInvite(selectedUser.email, cb));
  };

  const checkBoxOnChange = (event, data) => {
    setIfCheckboxChecked(data.checked);
  };

  let rightPanel = {};
  let centerPanel = {};

  rightPanel = (
    <RightPanelUpdate
      selectedUsers={props.selectedUsers}
      timezone={props.timezone}
      userName={props.userName}
      invalidUserEmails={invalidUserEmails}
      ifCheckboxChecked={ifCheckboxChecked}
    />
  );
  centerPanel = (
    <CenterPanelUpdate
      selectedUsers={props.selectedUsers}
      timezone={props.timezone}
      userName={props.userName}
      userSelectedCallBack={userSelectedCallBack}
      hasUserValidInvitation={hasUserValidInvitation}
      userLastInvited={userLastInvited}
      ifCheckboxChecked={ifCheckboxChecked}
      checkBoxOnChange={checkBoxOnChange}
    />
  );

  return (
    <Modal
      show={props.showWaitingAreaSelfProvisionModal}
      hideWhenClickAway={false}
      className={'wa-invite-self-provision'}
    >
      <PopupHeader
        helpLink={APP.EXTERNAL_LINKS.WaitingArea.SelfProvisionInvite}
        title={APP.LANGUAGE.WaitingAreaSelfProvision.headerLabel}
      />
      <div className="content">
        <div className="main-ui-container">
          <div id="righthandfloatingpanel" style={{ height: '410px' }}>
            <div className="right ui rail">
              <div className="ui sticky">{rightPanel}</div>
            </div>
            {centerPanel}
            <div className="bottom-rail-with-left-and-right-content mrtl">{rightPanel}</div>
          </div>
        </div>
      </div>
    </Modal>
  );
}
